import {
  DELETE_CONTACT_FAILURE,
  DELETE_CONTACT_REQUESTED,
  DELETE_CONTACT_SUCCESS,
} from 'actiontypes/contacts';

import ContactService from 'services/ContactService';

const service = new ContactService();

/** ----------------------------------------------------------------------------
 * DELETE A CONTACT
 -----------------------------------------------------------------------------*/
export default function deleteContact(userID) {
  return (dispatch) => {
    dispatch(deleteContactRequested());

    service.deleteContact(userID).then(
      response => dispatch(deleteContactSuccess(response.data, userID)),
      error => dispatch(deleteContactFailure(error)),
    );
  };
}

export const deleteContactRequested = () => ({ type: DELETE_CONTACT_REQUESTED, isDeleting: true });

export const deleteContactSuccess = (data, userID) => ({
  type: DELETE_CONTACT_SUCCESS,
  payload: {
    deletedUserId: userID,
    isDeleting: false,
    isSuccess: data.isSuccess,
    message: data.message,
  },
});

export const deleteContactFailure = error => ({
  type: DELETE_CONTACT_FAILURE,
  payload: {
    isDeleting: false,
    error: true,
    message: error.response && error.response.data.message,
    status: error.response && error.response.status,
  },
});